/**
 * Deploy subdirectory comes only from Vite `base` (import.meta.env.BASE_URL).
 * Route paths / menu links must NOT include this prefix — BrowserRouter basename handles it.
 */

/** Vite base always has a trailing slash, e.g. `/credo360/` or `/`. */
export function getAppBasePath() {
  const raw = (typeof import.meta !== "undefined" && import.meta.env?.BASE_URL) || "/";
  return raw.endsWith("/") ? raw.slice(0, -1) : raw;
}

/** React Router basename (no trailing slash). Empty/undefined when hosted at domain root. */
export const APP_BASENAME = getAppBasePath() || "";

/** Strip deploy basename from a pathname so `/credo360/login` → `/login`. */
export function stripAppBasename(pathname = "") {
  if (!pathname) {
    return "/";
  }
  const base = getAppBasePath();
  if (!base || base === "/") {
    return pathname;
  }
  if (pathname === base) {
    return "/";
  }
  if (pathname.startsWith(`${base}/`)) {
    return pathname.slice(base.length) || "/";
  }
  return pathname;
}

/** Absolute origin + basename for full-page redirects / emailed links. */
export function getFrontendBaseUrl() {
  if (typeof window === "undefined") {
    return "";
  }
  const base = getAppBasePath();
  return `${window.location.origin}${base === "/" ? "" : base}`;
}
